import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';

const AssetReturnList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Asset Return"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [assetReturnListData, setAssetReturnListData] = useState([]);
    const [loading, setLoading] = useState(true);


    const columns = {
        TXNName: { text: "Returned No.", align: "start", visible: true },
        AssetName: { text: "Asset", align: "start", visible: true },
        TXNDate: { text: "Returned Date", align: "center", visible: true },
        ReturnedFromName: { text: "Received From", align: "left", visible: true },
        ReturnedByName: { text: "Received By", align: "left", visible: true },
        Location: { text: "Location", align: "left", visible: true },
    };
    useEffect(() => {
        fetchGetAssetReturnMaster();
    }, []);

    const [apiStatus, SetApiStatus] = useState(undefined);
    const fetchGetAssetReturnMaster = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}asset-return?P_EmployeeID=0`);

            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setAssetReturnListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Vendor Master. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Vendor Master:", error);
        }
    };


    const handleAddNewAssetReturn = () => {
        navigate(`/asset-return/add`)
    }

    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={assetReturnListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={true}
                            showIcon2={false}
                            isSorting={true}
                            isActionRequired={false}
                            isAddNewBtnRequired={true}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            // handleIcon1={handleEdit}
                            handleAddNew={handleAddNewAssetReturn}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default AssetReturnList